import React from 'react';
import { Image as BuilderImage } from '@builder.io/react';
import { Link } from 'gatsby';

const SponsorCard = ({ logo, name, url }) => (
  <div className='col-md-6'>
    <div className='team-item'>
      <div className='team-inner-wrap'>
        <Link
          className='images-wrap'
          to={url}
        >
          {logo ? (
            <BuilderImage image={logo} alt={`${name}'s logo`} />
          ) : (
            <h3 className='title-name' style={{ margin: '40px 0' }}>
              {name}
            </h3>
          )}
        </Link>
      </div>
    </div>
  </div>
);

export default SponsorCard;
